export const saveClientFacilityAndEventSelected = (
  clientSelect: { name: string; id: string },
  facilitySelect: { name: string; id: string },
  eventSelect: { name: string; id: string },
) => {
  localStorage.setItem('clientSelect', JSON.stringify(clientSelect));
  localStorage.setItem('facilitySelect', JSON.stringify(facilitySelect));
  localStorage.setItem('eventSelect', JSON.stringify(eventSelect));
};

export const removeClientFacilityAndEventSelected = () => {
  localStorage.removeItem('clientSelect');
  localStorage.removeItem('facilitySelect');
  localStorage.removeItem('eventSelect');
};

export const getClientSelect = () => {
  return localStorage.getItem('clientSelect');
};

export const getFacilitySelect = () => {
  return localStorage.getItem('facilitySelect');
};
export const getEventSelect = () => {
  return localStorage.getItem('eventSelect');
};

export const getReportId = () => {
  return localStorage.getItem('reportId');
};

export const saveReportId = (id: string) => {
  localStorage.setItem('reportId', id);
};

export const removeReportId = () => {
  localStorage.removeItem('reportId');
};

export const saveUseToLocalStorage = (data_user: any) => {
  const { accessToken, refreshToken, ...dataUserWithoutTokens } = data_user;
  localStorage.setItem('data_user', JSON.stringify(dataUserWithoutTokens));
};

export const getUserFromLocalStorage = (): any => {
  let data = {};
  if (localStorage.getItem('data_user')) {
    try {
      const userLocal = localStorage.getItem('data_user');
      data = JSON.parse(userLocal ? userLocal : '');
    } catch (e) {
      data = {};
    }
  }
  return data;
};

export const removeUserFromLocalStorage = () => {
  localStorage.removeItem('data_user');
};

export const saveClientUserToLocalStorage = (client: any) => {
  localStorage.setItem('clientUser', JSON.stringify(client));
};

export const removeClientUserFromLocalStorage = () => {
  localStorage.removeItem('clientUser');
};

export const getClientUserFromLocalStorage = () => {
  return localStorage.getItem('clientUser') ?? '';
};

export const saveConsultantToLocalStorage = (consultant: any) => {
  localStorage.setItem('consultant', JSON.stringify(consultant));
};

export const removeConsultantFromLocalStorage = () => {
  localStorage.removeItem('consultant');
};

export const getConsultantFromLocalStorage = () => {
  return localStorage.getItem('consultant') ?? '';
};

export const saveEmployeeWebToLocalStorage = (employee: any) => {
  localStorage.setItem('employeeWebUser', JSON.stringify(employee));
};

export const removeEmployeeWebFromLocalStorage = () => {
  localStorage.removeItem('employeeWebUser');
};

export const saveUserToChatToLocalStorage = (data_user: any) => {
  localStorage.setItem('data_user_chat', JSON.stringify(data_user));
};

export const getUserToChatFromLocalStorage = (): any => {
  let data: any = {};
  try {
    const userLocal = localStorage.getItem('data_user_chat');
    data = JSON.parse(userLocal ? userLocal : '');
  } catch (e) {
    data = {};
  }
  return data;
};

export const removeUserToChatFromLocalStorage = () => {
  localStorage.removeItem('data_user_chat');
};
